
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      default: '',
      type: [String, Number]
    }
  },

  emits: ['update:modelValue']
})
